import { z } from 'zod'

export const bankingInformationSchema = z.object({
  bankAccounts: z
    .array(
      z.object({
        id: z.string().nullish(),
        bankName: z.string().min(1),
        routingNumber: z
          .string()
          .min(1)
          .length(9, 'routingNumberLength')
          .regex(/^\d+$/, 'routingNumberDigitsOnly'),
        accountNumber: z
          .string()
          .min(1)
          .min(4, 'accountNumberMinLength')
          .max(17, 'accountNumberMaxLength')
          .regex(/^\d+$/, 'accountNumberDigitsOnly'),
        accountType: z.string().min(1)
      })
    )
    .min(1)
})

export type BankingInformationForm = z.infer<typeof bankingInformationSchema>
